// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.background[data-v-48ed92b0] {
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
  background-color: rgba(255, 255, 255, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  z-index: 15 !important;
}
.modal[data-v-48ed92b0] {
  box-shadow: 0px 0px 15px lightgray;
  display: contents;
  border-color: #4b647d;
}
p[data-v-48ed92b0] {
  color: #4b647d;
}
p.additional[data-v-48ed92b0] {
  font-size: 0.8em;
  margin-bottom: 0;
}
p.question[data-v-48ed92b0] {
  margin: 1em;
}
.modal-content[data-v-48ed92b0] {
  top: 10vh;
}
.modal-header[data-v-48ed92b0] {
  background-color: #fac300;
  color: #4b647d;
}
.modal-dialog[data-v-48ed92b0] {
  z-index: 20 !important;
}
h1[data-v-48ed92b0] {
  font-size: 1.2em;
}
.close-button[data-v-48ed92b0] {
  cursor: pointer;
  text-decoration: none;
  width: 1em;
  margin-left: auto;
}
.close-button[data-v-48ed92b0]:hover {
  opacity: 0.8;
}
`, "",{"version":3,"sources":["webpack://./src/components/QuizCardModal.vue"],"names":[],"mappings":";AA+BA;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,0CAA0C;EAC1C,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,YAAY;AACd","sourcesContent":["<script setup lang=\"ts\">\nimport { QuizCard } from '@/models';\nimport { i18n } from '@/assets/i18n';\nimport { store } from '@/store';\n\nconst emit = defineEmits(['onClose']);\nconst props = defineProps<{\n  card: QuizCard;\n}>();\n</script>\n\n<template>\n  <div class=\"background\" />\n  <div class=\"modal fade\" id=\"quizcard-modal\">\n    <div class=\"modal-dialog\">\n      <div class=\"modal-content\">\n        <div class=\"modal-header\">\n          <h1 class=\"modal-title\">{{ i18n('QUIZCARD_TITLE') + card.id }}</h1>\n          <span class=\"close-button\" @click=\"emit('onClose')\">×</span>\n        </div>\n        <div class=\"modal-body\">\n          <p class=\"additional\">{{ i18n('QUIZCARD_DESCRIPTION') }}</p>\n          <p class=\"question\">{{ card.question[store.lang] }}</p>\n          <p class=\"additional\">{{ i18n('QUIZCARD_INSTRUCTION') }}</p>\n        </div>\n      </div>\n    </div>\n  </div>\n</template>\n\n<style scoped>\n.background {\n  backdrop-filter: blur(3px);\n  -webkit-backdrop-filter: blur(3px);\n  background-color: rgba(255, 255, 255, 0.5);\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100%;\n  z-index: 15 !important;\n}\n.modal {\n  box-shadow: 0px 0px 15px lightgray;\n  display: contents;\n  border-color: #4b647d;\n}\np {\n  color: #4b647d;\n}\np.additional {\n  font-size: 0.8em;\n  margin-bottom: 0;\n}\np.question {\n  margin: 1em;\n}\n.modal-content {\n  top: 10vh;\n}\n.modal-header {\n  background-color: #fac300;\n  color: #4b647d;\n}\n.modal-dialog {\n  z-index: 20 !important;\n}\nh1 {\n  font-size: 1.2em;\n}\n.close-button {\n  cursor: pointer;\n  text-decoration: none;\n  width: 1em;\n  margin-left: auto;\n}\n.close-button:hover {\n  opacity: 0.8;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
